/**
 * Cart drawer upsell: AJAX add-to-cart via button click (avoids nested-form issues).
 */
(function () {
    function getCartDrawer() {
      return document.querySelector('cart-drawer');
    }
  
    function setLoading(button, isLoading) {
      if (!button) return;
      if (isLoading) {
        button.setAttribute('aria-disabled', 'true');
        button.disabled = true;
        button.classList.add('loading');
        const spinner = button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');
        return;
      }
  
      button.removeAttribute('aria-disabled');
      button.disabled = false;
      button.classList.remove('loading');
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    }
  
    function buildUpsellLineProperties(button) {
      const gid = Math.random().toString().slice(2, 11);
      const priceCents = parseInt(button.dataset.variantPrice || '0', 10);
      const properties = {
        _gid: gid,
        _product: 'true',
        _ymal: 'true',
      };
      if (!Number.isNaN(priceCents) && priceCents > 0) {
        const perUnit = parseFloat((priceCents / 100).toFixed(2));
        properties._main_fees = String(perUnit);
        properties.Gift = '$' + perUnit.toFixed(2);
      }
      return properties;
    }

    function addUpsellToCart(button) {
      const variantId = button.dataset.variantId;
      if (!variantId || !window.routes?.cart_add_url) return;
      if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;
  
      const cartDrawer = getCartDrawer();
      const sections =
        cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'
          ? cartDrawer
              .getSectionsToRender()
              .map((section) => section.id)
              .filter(Boolean)
              .join(',')
          : 'cart-drawer,cart-icon-bubble';
  
      setLoading(button, true);
  
      if (cartDrawer && typeof cartDrawer.setActiveElement === 'function') {
        cartDrawer.setActiveElement(button);
      }
  
      const config =
        typeof fetchConfig === 'function'
          ? fetchConfig('javascript')
          : {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/javascript',
              },
            };
  
      config.body = JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: buildUpsellLineProperties(button),
          },
        ],
        sections: sections,
        sections_url: window.location.pathname,
      });
  
      fetch(window.routes.cart_add_url, config)
        .then((res) => res.json())
        .then((parsedState) => {
          if (parsedState?.status) {
            if (typeof console !== 'undefined') {
              console.error('Cart drawer upsell add failed:', parsedState);
            }
            return;
          }
  
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-drawer-upsell',
              productVariantId: variantId,
            });
          }
  
          if (cartDrawer && parsedState?.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(parsedState, { openDrawer: false });
          }
  
          document.dispatchEvent(new CustomEvent('cart-drawer:updated'));
        })
        .catch((err) => {
          if (typeof console !== 'undefined') console.error('Cart drawer upsell error:', err);
        })
        .finally(() => setLoading(button, false));
    }
  
    document.addEventListener(
      'click',
      function (event) {
        const button = event.target?.closest?.('[data-cart-drawer-upsell-add]');
        if (!button) return;
  
        event.preventDefault();
        event.stopPropagation();
  
        addUpsellToCart(button);
      },
      true,
    );
  })();
  
  /**
   * Cart drawer upsell Swiper init.
   */
  (function () {
    const SWIPER_INSTANCE_KEY = '__cartDrawerUpsellSwiperInstance';
  
    function getUpsellElement() {
      return (
        document.getElementById('CartDrawerUpsellSwiper') ||
        document.querySelector('.js-cart-drawer-ymal-swiper')
      );
    }
  
    function getInstance() {
      return window[SWIPER_INSTANCE_KEY];
    }
  
    function setInstance(instance) {
      window[SWIPER_INSTANCE_KEY] = instance;
    }
  
    function destroyInstance() {
      const instance = getInstance();
      if (!instance) return;
      try {
        instance.destroy(true, true);
      } catch (e) {
        // no-op
      }
      setInstance(null);
    }
  
    function initUpsellSwiper(attempt) {
      const tries = typeof attempt === 'number' ? attempt : 0;
      const el = getUpsellElement();
  
      if (!el) {
        destroyInstance();
        return;
      }
  
      const slideCount = el.querySelectorAll('.swiper-slide').length;
      if (slideCount === 0) {
        destroyInstance();
        return;
      }
  
      const scrollbarElement = el.querySelector('[data-ymal-scrollbar]');
  
      if (typeof window.Swiper === 'undefined') {
        if (tries < 40) {
          setTimeout(function () {
            initUpsellSwiper(tries + 1);
          }, 100);
        }
        return;
      }
  
      const instance = getInstance();
      if (instance && !instance.destroyed) {
        const instanceEl = instance.el;
        if (instanceEl && !document.body.contains(instanceEl)) {
          destroyInstance();
        } else if (instanceEl === el) {
          instance.update();
          return;
        } else {
          destroyInstance();
        }
      }
  
      const swiperConfig = {
        slidesPerView: 1.2,
        spaceBetween: 12,
        loop: false,
        grabCursor: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        preventClicks: false,
        preventClicksPropagation: false,
        noSwipingClass: 'swiper-no-swiping',
      };
  
      if (scrollbarElement) {
        swiperConfig.scrollbar = {
          el: scrollbarElement,
          draggable: true,
          hide: false,
        };
      }
  
      const swiper = new window.Swiper(el, swiperConfig);
  
      setInstance(swiper);
    }
  
    function scheduleInit(delay) {
      const wait = typeof delay === 'number' ? delay : 0;
      setTimeout(function () {
        requestAnimationFrame(function () {
          initUpsellSwiper();
        });
      }, wait);
    }
  
    document.addEventListener('DOMContentLoaded', function () {
      scheduleInit(0);
      scheduleInit(300);
    });
  
    function onCartDrawerContentChanged() {
      attachDrawerInnerObserver();
      scheduleInit(0);
      scheduleInit(120);
      scheduleInit(260);
    }
  
    document.addEventListener('cart-drawer:updated', onCartDrawerContentChanged);
    document.addEventListener('cart:updated', onCartDrawerContentChanged);
  
    function attachDrawerInnerObserver() {
      const drawerInner = document.querySelector('#CartDrawer .drawer__inner');
      if (!drawerInner || drawerInner._upsellSwiperObserverAttached) return;
  
      const observer = new MutationObserver(function () {
        if (getUpsellElement()) onCartDrawerContentChanged();
      });
  
      observer.observe(drawerInner, { childList: true, subtree: true });
      drawerInner._upsellSwiperObserverAttached = true;
    }
  
    document.addEventListener('DOMContentLoaded', function () {
      attachDrawerInnerObserver();
    });
  
    window.addEventListener('resize', function () {
      scheduleInit(80);
    });
  })();